// Part of a project of bettercom it-services gmbh, Hamburg, DE
// $Id$
//

JQ(document).ready(function () {

    ALL.initDoc();
    PRIV.hideLogoutAndAdministration();

    ALL.chgProduct('bawe', null);
    ALL.chgProduct('glas', null);
    ALL.chgProduct('muri', null);
    ALL.chgProduct('unfa', null);
    ALL.chgProduct('unfa1', null);
    ALL.chgProduct('unfa2', null);
    ALL.chgProduct('thv', null);

    // Form für Deckungsauftrag / Antrag (buttons werden in get_da0 definiert)
    JQ('#div_da').dialog({
        autoOpen: false,
        height: 550,
        modal: true,
        title: "Antrag / Deckungsauftrag vorbereiten",
        width: 530,
    });

    JQ('.docbox').click(function () {
        JQ('#div_' + PRIV.get_branch(this) + '_docs_1').toggle();
    });

    JQ('#div_bawe_vers').change(BAWE.change);
    JQ('#div_glas_vers').change(GLAS.change);
    JQ('#div_muri_vers').change(MURI.change);
    JQ('#div_unfa_vers').change(UNFA.change);
    JQ('#div_unfa1_vers').change(UNFA.change);
    JQ('#div_unfa2_vers').change(UNFA.change);

    JQ('#div_da').change(PRIV.chkDA);

    JQ('#DataVN').change(ALL.haveVN);
    JQ('#a_datavn').click(ALL.haveVN);

    JQ('#div_unfa_rslt').change(UNFA.chgZW);
    JQ('#div_unfa1_rslt').change(UNFA.chgZW);
    JQ('#div_unfa2_rslt').change(UNFA.chgZW);

    JQ('#toHomepageButton').click(function () {
        window.location = "https://waldenburger.com";
    });

    JQ('#rateOnGoogleButton').click(function () {
        window.open('https://g.page/r/CRTqNtoPXN3qEAg/review', '_blank');
    });

    //JQ('div .rslt').change(PRIV.chgZW);

    ALL.branches = PRIV.branches;
    JQ.each(PRIV.branches, function (i, v) {
        // Nur bei Bauwesen lassen wir eigene von anderen Sparten abweichende Anschrift zu!
        //if (v == 'bawe') return true;
        // Alle anderen Sparten werden "gleichgeschaltet".
        JQ('#f_' + v + '_plz').change(ALL.chkPLZ);
        JQ('#f_' + v + '_ort').change(ALL.chkORT);
        JQ('#f_' + v + '_str').change(ALL.chkSTR);
        JQ('#f_' + v + '_hnr').change(ALL.chkHNR);
    });

    JQ("#f_muri_wf").change(MURI.chkWF);
    JQ("#f_woge_wf").change(WOGE.chkWF);

    JQ('#btn_set_plz_ort').click(ALL.setVNadr);
    JQ('#f_vn_plz').change(ALL.chkPLZ);
    JQ('#f_vn_ort').change(ALL.chkORT);
    JQ('#f_vn_str').change(ALL.chkSTR);
    JQ('#f_vn_hnr').change(ALL.chkHNR);

    // "Angebot (PDF)" und "Antrag / Auftrag" Buttons in Prämienliste
    // unterhalb von "VN / Kunde" aktivieren.
    JQ('.btn4an').button({
        text: true,
        disabled: true,
    }).click(PRIV.get_da0);

    JQ('.btn4da').button({
        text: true,
        disabled: true,
    }).click(PRIV.get_onr);

    JQ('#btn_getdocs').button({
        text: true,
        disabled: true,
    }).click(PRIV.requestOffer);

    // Buttons für Angebots- und DA-Listen nach Einloggen aktivieren.
    JQ('#btn_ans').button({
        text: true,
    }).click(PRIV.loadANs);
    JQ('#a_an_list').click(PRIV.loadANs);

    JQ('#btn_das').button({
        text: true,
    }).click(PRIV.loadDAs);
    JQ('#a_da_list').click(PRIV.loadDAs);

    PRIV.direct = JQ('#f_direct').length ? true : false;

    $('#reset_form').click(function(event) {
        event.preventDefault();
        $('<div id="reset_form_confirmation_dialog">Alle Formularfelder leeren und neue VN Daten erfassen?</div>').appendTo('body');


        JQ("#reset_form_confirmation_dialog").dialog({
            modal: true,
            title: "Alle Formularfelder zurücksetzen?",
            resizable: false,
            buttons: {
                "Formularfelder zurücksetzen": function () {
                    location.reload();
                },

                "Abbrechen": function () {
                    JQ("#reset_form_confirmation_dialog").dialog("destroy");
                    JQ("#reset_form_confirmation_dialog").remove();
                }
            },
        });
    });

    JQ('.stepbtn').click(ALL.chgDiv);
    ALL.notifyHeight();
    //JQ('#btn_fwd_0, #svg_fwd_c00').click(ALL.chgDiv);

});

global.PRIV = {
    // Variablen und Funktionen, die in allen Sub-Sparten benötigt werden
    an_read: false,
    wd_read: false,
    // Im ans-dict speichern wir über alle Sparten hinweg eine Risikoanschrift,
    // die bei der Änderung in einer Sparte bei allen anderen ebenfalls geändert
    // wird.
    // Array für Bedingungsteile, die mittels ZIP/getzip beim DA heruntergeladen werden können
    bparts: {},
    branch: 'priv',
    branches: ['bawe', 'fhrd', 'glas', 'hara', 'hara1', 'hara2',
        'muri', 'phth', 'phth1', 'phth-hh', 'phth-wh', 'phvo',
        'unfa', 'unfa1', 'unfa2', 'woge', 'thv'],
    calcable: false,
    canDA: false,
    da_onr: '',
    direct: false,
    // 0 = ohne Dauernachlass, 1 = mit Dauernachlass 3 Jahre
    dnls: 0,
    PLZset: false,
    // Angaben zu Vorversicherungen (vv3: Gesellschaft, vv4: VSNR) aus Produktseiten:
    vv: {vv3: '', vv4: ''},
    // Vorversicherungs- / Vorschadenzeitraum, der abgefragt wird
    vv_yy: 5,
    ZUERSset: false,

    createBundleRabattFieldsForBranch: function (branch) {
        var dropdown = JQ('#f_' + branch + '_rbt_bundle');
        var textAreaContainer = JQ('#bundle-rbt-text-container-' + branch);

        dropdown.change(function () {
            var selected = parseInt(dropdown.find('option:selected').val());
            if (selected >= 5) {
                textAreaContainer.css('display', 'table');
                textAreaContainer.change(function () {
                    // Force recalc if textArea has been changed.
                    PRIV.chkZW();
                });
            } else {
                textAreaContainer.css('display', 'none');
            }
            ALL.notifyHeight();
        });
    },

    chk4re_ok: function () {
        // Zahlung per Rechnung ok?
        var btr = ALL.cur2flt(JQ('#f_all_' + PRIV.branch).text());
        var re_notok = btr < 20.0;
        var hint = re_notok ? 'Zahlung per Rechnung erst ab Beitrag von mind. 20 € möglich' : '';
        BC.debug('PRIV.chk4re_ok(): ', [btr, re_notok], 64);
        JQ('#f_da_za_2').prop({
            disabled: re_notok,
            title: hint
        });
    },

    chkDA: function () {
        // Kann DA/Antrag geposted werden?
        var r;
        if (ALL.mobile) {
            r = PRIV.chkDA1();
        } else {
            r = PRIV.chkDA0();
        }
        return r;
    },

    chkDA1: function () {
        // Kann DA/Antrag geposted werden?
        BC.debug('PRIV.chkDA1() starting in ', PRIV.branch, 64);
        var _unfa = PRIV.branch.slice(0, 4) === 'unfa';
        var needed = {
            vv0: [true, 'Angabe ob Antrag schonmal abgelehnt wurde'],
            vv1: [true, 'Angabe, ob eine Vorversicherung bestand, fehlt'],
            vv1a: [false, 'Erläuterung für nicht vorhandene Vorversicherung in den letzten 5 Jahren fehlt.'],
            vv2: [false, 'Angabe, wer den Vorversicherungsvertrag gekündigt hat, fehlt.'],
            vv3: [true, 'Name der Vorversicherungsgesellschaft fehlt.'],
            vv4: [true, 'Nummer des Vorversicherungsvertrages fehlt.'],
            vv5: [true, 'Ablaufdatum des Vorversicherungsvertrages.'],
            vv6a: [false, 'Beschreibung, Höhe und Datum des Vorschadens fehlen.'],
        };
        JQ('#btn_da_ok').button('disable');
        UNFA.o_possible = false;
        if (JQ('#f_da_vv0_1').is(':checked')) {
            ALL.showHint('Die Übernahme des Versicherungsschutzes ist aufgrund vorheriger Antrags-Ablehnungen bei der Waldenburger leider nicht möglich.', true);
            return false;
        }
        if (JQ('#f_da_vv2_2').is(':checked')) {
            ALL.showHint('Die Übernahme des Versicherungsschutzes ist aufgrund der Kündigung durch den Vorversicherer bei der Waldenburger leider nicht möglich.', true);
            return false;
        }
        if (JQ('#f_da1_3_1').is(':checked') && !JQ('#f_da_rem').val()) {
            ALL.showInfo('Bitte erläutern Sie im nachstehenden Feld "Bemerkungen" den bzw. die Vorschäden mit Angabe von Schadendatum und Schadenereignis. Eine möglichst präzise Angabe erleichtert der Waldenburger die erforderliche Risikoprüfung.', 'Weitere Informationen erforderlich', true);
            return false;
        }

        ALL.notifyHeight();
        if (ALL.checkIfBikeProdYearIsCurrentYear()) {
            needed.vv1[0] = false;
            needed.vv3[0] = false;
            needed.vv4[0] = false;
            needed.vv5[0] = false;
            needed.vv6a[0] = false;
        }

        if (!JQ('#f_da_vv0_0').is(':checked')) {
            return false;
        }
        if (JQ('#f_da_vv1_1').is(':checked')) {
            // Es bestand eine Vorversicherung
            JQ('#div_da_vv2').show();
            needed.vv2[0] = true;
            JQ('#div_da_vv3').show();
            needed.vv3[0] = true;
            JQ('#div_da_vv4').show();
            needed.vv4[0] = true;
            JQ('#div_da_vv5').show();
            needed.vv5[0] = true;
            JQ('#div_da_vv1a').hide();
            needed.vv1a[0] = false;
        } else if (JQ('#f_da_vv1_0').is(':checked')) {
            // Es bestand keine Vorversicherung
            JQ('#div_da_vv2').hide();
            needed.vv2[0] = false;
            JQ('#div_da_vv3').hide();
            needed.vv3[0] = false;
            JQ('#div_da_vv4').hide();
            needed.vv4[0] = false;
            JQ('#div_da_vv5').hide();
            needed.vv5[0] = false;
            if (!_unfa) {
                BC.debug('Vorversicherungsfrage - ', 'NON Unfall', 64);
                JQ('#div_da_vv1a').show();
                needed.vv1a[0] = true;
                if (JQ(this).prop('id') === 'f_da_vv1_0') ALL.showHint('Bitte erläutern Sie in dem entsprechenden Feld kurz, warum in den letzten ' + PRIV.vv_yy + ' Jahren kein Versicherungsschutz vorhanden war.');
            }
        }
        ALL.notifyHeight();
        if (JQ('#f_da_vv6').length) {
            // Anzahl Vorschäden in den letzten 5 bzw. 10 Jahren
            BC.debug('PRIV.chkDA() - f_da_vv6: ' + JQ('#f_da_vv6').val() + ' Vorschäden', this, 64);
            if (JQ('#f_da_vv6').val() === '0') {
                // Keine Vorschäden
                JQ('#div_da_vv6a').hide();
                needed.vv6a[0] = false;
            } else if (JQ('#f_da_vv6').val() === '1') {
                // Ein Vorschaden, Erläuterung benötigt
                JQ('#div_da_vv6a').show();
                needed.vv6a[0] = true;
                if (!ALL.mobile && !JQ('#f_da_vv6a').val()) ALL.showHint('Bitte erläutern Sie in dem entsprechenden Feld den Schaden inkl. Schadenjahr und Schadenhöhe.');
            } else if (JQ('#f_da_vv6').val() !== '0' && JQ('#f_da_vv6').val() !== '1') {
                JQ('#div_da_vv6a').hide();
                ALL.showHint('Die Übernahme des Versicherungsschutzes durch die Waldenburger Versicherung ist bei mehr als einem Vorschaden in den vergangenen Jahren leider nicht möglich.', true);
                return false;
            }
        }
        if (_unfa && UNFA.chkDA4allvps()) return false;
        //if (_unfa && JQ('#f_da_vv6').val() == '0') PRIV.canDA = true;
        PRIV.canDA = true;
        JQ.each(needed, function (k, v) {
            BC.debug('PRIV.chkDA1() - Looping through ', [k, v], 64);
            // Prüfe nochmals, ob alle erforderlichen Felder (var needed) gefüllt sind.
            // Aber nur, wenn die Felder keine options sind, dafür erfolgt die Prüfung
            // separat.
            if (JQ('#f_da_' + k + '_0').length || JQ('#f_da_' + k + '_1').length) return true;
            if (!JQ('#f_da_' + k).length) return true;
            if (v[0] && JQ('#f_da_' + k).length && !JQ('#f_da_' + k).val()) {
                if (!ALL.mobile) ALL.showHint('Die Verarbeitung des Antrags ist nicht möglich: ' + v[1]);
                else BC.debug('PRIV.chkDA1() - Problem with ', [k, v], 64);
                JQ('#f_da_' + k).prop('required', true).focus();
                PRIV.canDA = false;
                return false;
                // } else if (v[0] && JQ('#f_da_' + k).val()) {
                // PRIV.canDA = true;
            } else if (!v[0]) {
                JQ('#f_da_' + k).prop('required', false);
            }
        });
        //UNFA.o_possible = PRIV.canDA;
        return PRIV.canDA;
    },

    chkDA2: function () {
        // Kann DA/Antrag geposted werden?
        BC.debug('PRIV.chkDA2() starting in ', PRIV.branch, 64);
        var needed = {
            iban: [false, 'IBAN fehlt.'],
        };
        if (JQ('#f_da_za_1').is(':checked')) {
            // Zahlung per Lastschrift, Konto benötigt
            JQ('#div_da_iban').show();
            needed.iban[0] = true;
        } else {
            // Zahlung per Rechnung, kein Konto benötigt
            JQ('#div_da_iban').hide();
            needed.iban[0] = false;
        }
        ALL.notifyHeight();
        if (JQ('#f_da3_0').is(':checked') &&
            JQ('#f_da3_1').is(':checked') &&
            JQ('#f_da3_2').is(':checked') &&
            (!JQ('#f_da3_3').length ||
                JQ('#f_da3_3').is(':checked'))) {
            // Alle Bestätigungen im letzten Block vorhanden!
            // Prüfe einzelne Felder
            if (needed.iban[0] &&
                (!JQ('#f_da_iban').val() ||
                    !JQ('#f_da_levok').is(':checked'))) {
                BC.debug('PRIV.chkDA2(), Missing IBAN', this, 64);
                ALL.showHint('Die IBAN und/oder das SEPA-Mandat sind nicht ausgefüllt.');
                PRIV.canDA = false;
                return false;
            } else if (needed.iban[0] &&
                JQ('#f_da_levok').is(':checked') &&
                JQ('#f_da_iban').val() &&
                chk_iban(JQ('#f_da_iban').val()) != '1') {
                ALL.showHint('Die IBAN ist nicht korrekt, bitte überprüfen Sie die Eingabe.');
                PRIV.canDA = false;
                return false;
            }
            if (!PRIV.an_read || !PRIV.wd_read) {
                PRIV.canDA = false;
                ALL.showHint('Bitte öffnen Sie mittels obiger Links das Angebot und/oder laden die Bedingungen herunter.');
                JQ('#f_da3_1').attr('checked', false)
                return PRIV.canDA;
            }
            PRIV.canDA = true;
            return true;
        }
        return false;
    },

    chkDA0: function () {
        // Kann DA/Antrag geposted werden?
        BC.debug('PRIV.chkDA0() starting in ', PRIV.branch, 64);
        var _unfa = PRIV.branch.slice(0, 4) === 'unfa';
        var needed = {
            iban: [false, 'IBAN fehlt.'],
            vv1: [true, 'Angabe, ob eine Vorversicherung bestand, fehlt'],
            vv1a: [false, 'Erläuterung für nicht vorhandene Vorversicherung in den letzten 5 Jahren fehlt.'],
            vv2: [false, 'Angabe, wer den Vorversicherungsvertrag gekündigt hat, fehlt.'],
            vv3: [true, 'Name der Vorversicherungsgesellschaft fehlt.'],
            vv4: [true, 'Nummer des Vorversicherungsvertrages fehlt.'],
            vv5: [true, 'Ablaufdatum des Vorversicherungsvertrages.'],
            vv6a: [false, 'Beschreibung, Höhe und Datum des Vorschadens fehlen.'],
        };
        JQ('#btn_da_ok').button('disable');
        if (JQ('#f_da_vv0_1').is(':checked')) {
            ALL.showHint('Die Übernahme des Versicherungsschutzes ist aufgrund vorheriger Antrags-Ablehnungen bei der Waldenburger leider nicht möglich.', true);
            return false;
        }
        if (JQ('#f_da_vv2_2').is(':checked')) {
            ALL.showHint('Die Übernahme des Versicherungsschutzes ist aufgrund der Kündigung durch den Vorversicherer bei der Waldenburger leider nicht möglich.', true);
            return false;
        }
        if (JQ('#f_da_za_1').is(':checked')) {
            // Zahlung per Lastschrift, Konto benötigt
            JQ('#div_da_iban').show();
            needed.iban[0] = true;
        } else {
            // Zahlung per Rechnung, kein Konto benötigt
            JQ('#div_da_iban').hide();
            needed.iban[0] = false;
        }
        if (JQ('#f_da_vv1_1').is(':checked')) {
            // Es bestand eine Vorversicherung
            JQ('#div_da_vv2').show();
            needed.vv2[0] = true;
            JQ('#div_da_vv3').show();
            needed.vv3[0] = true;
            JQ('#div_da_vv4').show();
            needed.vv4[0] = true;
            JQ('#div_da_vv5').show();
            needed.vv5[0] = true;
            JQ('#div_da_vv1a').hide();
            needed.vv1a[0] = false;
        } else if (JQ('#f_da_vv1_0').is(':checked')) {
            // Es bestand keine Vorversicherung
            JQ('#div_da_vv2').hide();
            needed.vv2[0] = false;
            JQ('#div_da_vv3').hide();
            needed.vv3[0] = false;
            JQ('#div_da_vv4').hide();
            needed.vv4[0] = false;
            JQ('#div_da_vv5').hide();
            needed.vv5[0] = false;
            if (!_unfa) {
                BC.debug('PRIV.chkDA0(): Vorversicherungsfrage - ', 'NON Unfall', 64);
                JQ('#div_da_vv1a').show();
                needed.vv1a[0] = true;
                if (JQ(this).prop('id') === 'f_da_vv1_0') ALL.showHint('Bitte erläutern Sie in dem entsprechenden Feld kurz, warum in den letzten ' + PRIV.vv_yy + ' Jahren kein Versicherungsschutz vorhanden war.');
            }
        }
        ALL.notifyHeight();
        if (JQ('#f_da_vv6').length) {
            // Anzahl Vorschäden in den letzten 5 bzw. 10 Jahren
            BC.debug('PRIV.chkDA0() - f_da_vv6: ' + JQ('#f_da_vv6').val() + ' Vorschäden', this, 64);
            if (JQ('#f_da_vv6').val() === '0') {
                // Keine Vorschäden
                JQ('#div_da_vv6a').hide();
                needed.vv6a[0] = false;
            } else if (JQ('#f_da_vv6').val() === '1') {
                // Ein Vorschaden, Erläuterung benötigt
                JQ('#div_da_vv6a').show();
                needed.vv6a[0] = true;
                if (!ALL.mobile && !JQ('#f_da_vv6a').val()) ALL.showHint('Bitte erläutern Sie in dem entsprechenden Feld den Schaden inkl. Schadenjahr und Schadenhöhe.');
            } else if (JQ('#f_da_vv6').val() !== '0' && JQ('#f_da_vv6').val() !== '1') {
                JQ('#div_da_vv6a').hide();
                ALL.showHint('Die Übernahme des Versicherungsschutzes durch die Waldenburger Versicherung ist bei mehr als einem Vorschaden in den vergangenen Jahren leider nicht möglich.', true);
                return false;
            }
        }
        if (JQ('#f_da3_0').is(':checked') &&
            JQ('#f_da3_1').is(':checked') &&
            JQ('#f_da3_2').is(':checked') &&
            (!JQ('#f_da3_3').length ||
                JQ('#f_da3_3').is(':checked'))) {
            // Alle Bestätigungen im letzten Block vorhanden!
            // Prüfe einzelne Felder
            if (PRIV.branch == 'unfa' || PRIV.branch == 'unfa1' || PRIV.branch == 'unfa2') {
                PRIV.canDA = UNFA.chkDA4vp();
                if (!PRIV.canDA) {
                    ALL.showHint('Es sind nicht alle Gesundheitsfragen für jede VP beantwortet und / oder nicht alle Fragen sind mit Nein beantwortet worden.', true);
                    return false;
                }
            }
            if (needed.iban[0] &&
                (!JQ('#f_da_iban').val() ||
                    !JQ('#f_da_levok').is(':checked'))) {
                BC.debug('PRIV.chkDA0(), Missing IBAN', this, 64);
                ALL.showHint('Die IBAN und/oder das SEPA-Mandat sind nicht ausgefüllt.');
                PRIV.canDA = false;
                return false;
            } else if (needed.iban[0] &&
                JQ('#f_da_levok').is(':checked') &&
                JQ('#f_da_iban').val() &&
                chk_iban(JQ('#f_da_iban').val()) != '1') {
                ALL.showHint('Die IBAN ist nicht korrekt, bitte überprüfen Sie die Eingabe.');
                PRIV.canDA = false;
                return false;
            }
            if (!JQ('#f_da_vv0_0').is(':checked') && !JQ('#f_da_vv0_1').is(':checked')) {
                ALL.showHint('Bitte geben Sie an, ob in der Vergangenheit Anträge auf Versicherungsschutz abgelehnt wurden.');
                PRIV.canDA = false;
                return false;
            }
            if (!JQ('#f_da_vv1_0').is(':checked') && !JQ('#f_da_vv1_1').is(':checked') && !ALL.checkIfBikeProdYearIsCurrentYear()) {
                ALL.showHint('Bitte geben Sie an, ob eine Vorversicherung bestand.');
                PRIV.canDA = false;
                return false;
            }
            if (needed.vv2[0] && !JQ('#f_da_vv2_1').is(':checked') && !JQ('#f_da_vv2_2').is(':checked')) {
                ALL.showHint('Bitte geben Sie an, durch wen die Vorversicherung gekündigt wurde.');
                PRIV.canDA = false;
                return false;
            }
            JQ.each(needed, function (k, v) {
                BC.debug('PRIV.chkDA0() - Looping through ', [k, v], 64);
                // Prüfe nochmals, ob alle erforderlichen Felder (var needed) gefüllt sind.
                // Aber nur, wenn die Felder keine options sind, dafür erfolgt die Prüfung
                // separat.
                if (JQ('#f_da_' + k + '_0').length || JQ('#f_da_' + k + '_1').length) return true;
                if (_unfa && JQ('#f_da_vv6').val() == '0') PRIV.canDA = true;

                if (ALL.branch === 'fhrd') {
                    if (v[0] && !JQ('#f_da_' + k).val() && !ALL.checkIfBikeProdYearIsCurrentYear()) {
                        if (!ALL.mobile) ALL.showHint('Die Verarbeitung des Antrags ist nicht möglich: ' + v[1]);
                        JQ('#f_da_' + k).prop('required', true).focus();
                        PRIV.canDA = false;
                        BC.debug('PRIV.chkDA0() - Missing info for #f_da_' + k, v[1], 64);
                        return false;
                    } else if (v[0] && JQ('#f_da_' + k).val()) {
                        PRIV.canDA = true;
                    } else {
                        JQ('#f_da_' + k).prop('required', false);
                    }
                } else {
                    if (v[0] && !JQ('#f_da_' + k).val()) {
                        if (!ALL.mobile) ALL.showHint('Die Verarbeitung des Antrags ist nicht möglich: ' + v[1]);
                        JQ('#f_da_' + k).prop('required', true).focus();
                        PRIV.canDA = false;
                        BC.debug('PRIV.chkDA0() - Missing info for #f_da_' + k, v[1], 64);
                        return false;
                    } else if (v[0] && JQ('#f_da_' + k).val()) {
                        PRIV.canDA = true;
                    } else {
                        JQ('#f_da_' + k).prop('required', false);
                    }
                }

            });
            if (!PRIV.an_read || !PRIV.wd_read) {
                PRIV.canDA = false;
                ALL.showHint('Bitte öffnen Sie mittels obiger Links das Angebot und/oder laden die Bedingungen herunter.');
                JQ('#f_da3_1').attr('checked', false)
                return PRIV.canDA;
            } else if (!PRIV.an_read) {
                //PRIV.canDA = false;
                PRIV.canDA = !WALDI;
                BC.debug('PRIV.chkDA0(): Offer not downloaded', '', 64);
                //ALL.showHint('Bitte laden Sie das Angebot herunter.')
                return PRIV.canDA;
            }
            BC.debug('PRIV.chkDA0():', [PRIV.canDA, needed], 64);
            if (PRIV.canDA) {
                JQ('#btn_da_ok').button('enable');
                JQ('#f_da_set').val(1);
            }

        }

        BC.debug('PRIV.chkDA0() ends:', [PRIV.canDA, needed], 64);
        return PRIV.canDA;
    },

    chkDA3: function () {
        // Kann DA/Antrag geposted werden?
        BC.debug('PRIV.chkDA3() starting in ', PRIV.branch, 64);
        var _unfa = PRIV.branch.slice(0, 4) === 'unfa';
        var needed = {
            iban: [false, 'IBAN fehlt.'],
            vv1: [true, 'Angabe, ob eine Vorversicherung bestand, fehlt'],
            vv1a: [false, 'Erläuterung für nicht vorhandene Vorversicherung in den letzten 5 Jahren fehlt.'],
            vv2: [false, 'Angabe, wer den Vorversicherungsvertrag gekündigt hat, fehlt.'],
            vv3: [true, 'Name der Vorversicherungsgesellschaft fehlt.'],
            vv4: [true, 'Nummer des Vorversicherungsvertrages fehlt.'],
            vv5: [true, 'Ablaufdatum des Vorversicherungsvertrages.'],
            vv6a: [false, 'Beschreibung, Höhe und Datum des Vorschadens fehlen.'],
        };
        JQ('#btn_da_ok').button('disable');
        if (JQ('#f_da_vv0_1').is(':checked')) {
            ALL.showHint('Die Übernahme des Versicherungsschutzes ist aufgrund vorheriger Antrags-Ablehnungen bei der Waldenburger leider nicht möglich.', true);
            return false;
        }
        if (JQ('#f_da_vv2_2').is(':checked')) {
            ALL.showHint('Die Übernahme des Versicherungsschutzes ist aufgrund der Kündigung durch den Vorversicherer bei der Waldenburger leider nicht möglich.', true);
            return false;
        }
        if (JQ('#f_da_za_1').is(':checked')) {
            // Zahlung per Lastschrift, Konto benötigt
            JQ('#div_da_iban').show();
            needed.iban[0] = true;
        } else {
            // Zahlung per Rechnung, kein Konto benötigt
            JQ('#div_da_iban').hide();
            needed.iban[0] = false;
        }
        if (JQ('#f_da_vv1_1').is(':checked')) {
            // Es bestand eine Vorversicherung
            JQ('#div_da_vv2').show();
            needed.vv2[0] = true;
            JQ('#div_da_vv3').show();
            needed.vv3[0] = true;
            JQ('#div_da_vv4').show();
            needed.vv4[0] = true;
            JQ('#div_da_vv5').show();
            needed.vv5[0] = true;
            JQ('#div_da_vv1a').hide();
            needed.vv1a[0] = false;
        } else if (JQ('#f_da_vv1_0').is(':checked')) {
            // Es bestand keine Vorversicherung
            JQ('#div_da_vv2').hide();
            needed.vv2[0] = false;
            JQ('#div_da_vv3').hide();
            needed.vv3[0] = false;
            JQ('#div_da_vv4').hide();
            needed.vv4[0] = false;
            JQ('#div_da_vv5').hide();
            needed.vv5[0] = false;
            if (!_unfa) {
                BC.debug('Vorversicherungsfrage - ', 'NON Unfall', 64);
                JQ('#div_da_vv1a').show();
                needed.vv1a[0] = true;
                if (JQ(this).prop('id') === 'f_da_vv1_0') ALL.showHint('Bitte erläutern Sie in dem entsprechenden Feld kurz, warum in den letzten ' + PRIV.vv_yy + ' Jahren kein Versicherungsschutz vorhanden war.');
            }
        }
        ALL.notifyHeight();
        if (JQ('#f_da_vv6').length) {
            // Anzahl Vorschäden in den letzten 5 bzw. 10 Jahren
            BC.debug('PRIV.chkDA() - f_da_vv6: ' + JQ('#f_da_vv6').val() + ' Vorschäden', this, 64);
            if (JQ('#f_da_vv6').val() === '0') {
                // Keine Vorschäden
                JQ('#div_da_vv6a').hide();
                needed.vv6a[0] = false;
            } else if (JQ('#f_da_vv6').val() === '1') {
                // Ein Vorschaden, Erläuterung benötigt
                JQ('#div_da_vv6a').show();
                needed.vv6a[0] = true;
                if (!ALL.mobile && !JQ('#f_da_vv6a').val()) ALL.showHint('Bitte erläutern Sie in dem entsprechenden Feld den Schaden inkl. Schadenjahr und Schadenhöhe.');
            } else if (JQ('#f_da_vv6').val() !== '0' && JQ('#f_da_vv6').val() !== '1') {
                JQ('#div_da_vv6a').hide();
                ALL.showHint('Die Übernahme des Versicherungsschutzes durch die Waldenburger Versicherung ist bei mehr als einem Vorschaden in den vergangenen Jahren leider nicht möglich.', true);
                return false;
            }
        }
        if (!JQ('#f_da_vv0_0').is(':checked') && !JQ('#f_da_vv0_1').is(':checked')) {
            ALL.showHint('Bitte geben Sie an, ob in der Vergangenheit Anträge auf Versicherungsschutz abgelehnt wurden.');
            PRIV.canDA = false;
            return false;
        }
        if (!JQ('#f_da_vv1_0').is(':checked') && !JQ('#f_da_vv1_1').is(':checked')) {
            ALL.showHint('Bitte geben Sie an, ob eine Vorversicherung bestand.');
            PRIV.canDA = false;
            return false;
        }
        if (needed.vv2[0] && !JQ('#f_da_vv2_1').is(':checked') && !JQ('#f_da_vv2_2').is(':checked')) {
            ALL.showHint('Bitte geben Sie an, durch wen die Vorversicherung gekündigt wurde.');
            PRIV.canDA = false;
            return false;
        }
        JQ.each(needed, function (k, v) {
            BC.debug('PRIV.chkDA3() - Looping through ', [k, v], 512);
            // Prüfe nochmals, ob alle erforderlichen Felder (var needed) gefüllt sind.
            // Aber nur, wenn die Felder keine options sind, dafür erfolgt die Prüfung
            // separat.
            if (JQ('#f_da_' + k + '_0').length || JQ('#f_da_' + k + '_1').length) return true;
            if (_unfa && JQ('#f_da_vv6').val() == '0') PRIV.canDA = true;
            if (v[0] && !JQ('#f_da_' + k).val()) {
                if (!ALL.mobile) ALL.showHint('Die Verarbeitung des Antrags ist nicht möglich: ' + v[1]);
                JQ('#f_da_' + k).prop('required', true).focus();
                PRIV.canDA = false;
                return false;
            } else if (v[0] && JQ('#f_da_' + k).val()) {
                PRIV.canDA = true;
            } else {
                JQ('#f_da_' + k).prop('required', false);
            }
        });
        BC.debug('PRIV.chkDA3():', [PRIV.canDA, needed], 64);
        if (PRIV.canDA) {
            JQ('#btn_da_ok').button('enable');
            JQ('#f_da_set').val(1);
        }
        BC.debug('PRIV.chkDA3():', [PRIV.canDA, needed], 64);
        ALL.notifyHeight();
        return PRIV.canDA;
    },

    chk_f: function (k) {
        // Prüfe
        // 1. ob Feld k existiert und Wert hat oder
        // 2. ob Optionsgruppe für Feld k existiert.
        return k;
    },

    chkZW: function () {
        // Zahlweise geändert!
        // Alle Produkte neu berechnen!
        BAWE.recalc();
        FHRD.recalc();
        GLAS.recalc();
        HARA.recalc();
        MURI.recalc();
        PHTH.recalc();
        PHVO.recalc();
        WOGE.recalc();
    },

    get_branch: function (e) {
        // Liefert die Sparte des Feldes, also z.B. muri, hara, glas etc.
        // Die Sparte ist in den IDs i.d.R. der zweite Teil der durch
        // "_" geteilten IDs (z.B. f_hara_wf oder f_hara1_frd)
        var branch = ALL.get_branch(e);
        if (branch != 'vn' && branch.slice(0, 2) != 'da') PRIV.branch = branch;
        BC.debug('PRIV.get_branch() =>', [branch, PRIV.branch], 64);
        return PRIV.branch;
    },

    get_da0: function (e) {
        if (JQ(e.currentTarget).attr('id').indexOf('unfa') !== -1) {
            PRIV.branch = JQ(e.currentTarget).attr('id').replace('a_', '').replace('_an', '');
            UNFA.getOfferIdAndPostVersicherungspersonenToGetPdf();
            return;
        }
        // Ziel: Liefere Deckungsnote / Antrag
        if (!ALL.vn_set) {
            ALL.showHint('Ohne vollständige Angaben zum VN ist die Erstellung eines Angebots nicht möglich.');
            return;
        }
        BC.debug('PRIV.get_da0(): called for ' + PRIV.get_branch(this), this, 64);
        // Dokumentenliste unter Punkt 2 füllen:
        // Vorschadensituation abfragen und übernehmen!
        // Vorversicherersituation abfragen und übernehmen!
        //if (PRIV.branch === 'unfa' || PRIV.branch === 'unfa1') {
        // Bei Unfall keine Deckungsauftraege!
        //    BC.debug('PRIV.get_da0(): not allowed for: ' + PRIV.branch, '', 64);
        //    PRIV.requestOffer(e);
        //    return;
        //}
        if (BC.get_id(this).split('_').pop() == 'an') {
            BC.debug('PRIV.get_da0(): Einzel-Angebot anzeigen', '', 64);
            PRIV.pdfwin = window.open('', '_' + PRIV.branch);
            JQ.getJSON(JSONURI,
                {
                    action: 'offernr',
                    branch: PRIV.branch,
                    sid: JQ('#f_sid').val()
                },
                PRIV.showAN);
            return;
        }
        BC.debug('PRIV.get_da0(): Unwanted position reached!', '', 64);
        alert('Unbekannter Fehler ind PRIV.get_da0()');
    },

    get_da1: function () {
        // Hole Angebots-PDF vorab
        BC.debug('PRIV.get_da1(): called for ' + PRIV.branch, '', 64);
    },

    get_onr: function () {
        // Hole Offer-Nr für den Deckungsauftrag und hole anschließend
        // DA-Popup-Tmpl und zeige dieses im #div_da an
        if (!ALL.vn_set) {
            ALL.showHint('Ohne vollständige Angaben zum VN ist die Erstellung eines Angebots nicht möglich.');
            return;
        }
        BC.debug('PRIV.get_onr(): called for ' + PRIV.get_branch(this), this, 64);
        JQ.getJSON(JSONURI,
            {
                action: 'offernr',
                branch: PRIV.branch,
                sid: JQ('#f_sid').val()
            },
            PRIV.loadDAform);
    },

    get_prds: function () {
        // Liefere ein Array mit den Produkten, für die ein Beitrag
        // berechnet wurde
        var prds = [];
        var b = ''
        JQ('#div_all_rslt .button_r').each(function (i) {
            b = PRIV.get_branch(this);
            BC.debug('PRIV.get_prds(): Checking if f_' + b + '_make is 1', '', 256);
            if (JQ('#f_' + b + '_make').val() == '1' &&
                prds.indexOf(b) == -1) {
                prds.push(b);
                BC.debug('PRIV.get_prds(): Offer via POST for ' + b + ' requested', '', 256);
            }
        });
        BC.debug('PRIV.get_prds(): Enabled products are ', prds, 64);
        return prds;
    },

    init: function () {
        PRIV.hideReferenzField();
        BC.debug('PRIV.init():', '', 64);
        PRIV['fhrd'].init();
        PRIV['hara'].init();
        PRIV['phth'].init();
        PRIV['phvo'].init();
        PRIV['unfa'].init();
        PRIV['woge'].init();
        PRIV['glas'].init();
        PRIV['thv'].init();
        HARA.init('hara2');
        HARA.init('hara1');
        HARA.init('hara');
    },

    hideReferenzField: function () {
        var url = window.location.href;
        var startOfQuery = url.indexOf('?') + 1;
        var queryString = url.substring(startOfQuery);
        var queries = queryString.split('&');
        /** @var {object} kv */
        var queryParam = {};
        queries.forEach(function (query) {
            var arr = query.split('=');
            queryParam[arr[0]] = arr[1];
        })
        if (queryParam.vn_referenz) {
            JQ('#vn_referenz_block').hide();
            JQ('#f_vn_referenz').attr('required', false)
            JQ('#div_vn_referenz').hide();
        }
    },

    hideLogoutAndAdministration: function () {
        if (ALL.loadQueryParam().h === '1') {
            if (JQ('#logout').length) JQ('#logout').remove();
        }
    },

    loadANs: function () {
        // Lade Liste der Angebote
        BC.debug('PRIV.loadANs() called!', '', 64);
        JQ.getJSON(JSONURI,
            {
                action: 'list_ans',
                sid: JQ('#f_sid').val()
            },
            ALL.showANs);
    },

    loadDAform: function (data) {
        // callback für get_onr => Lade DA-Formular
        BC.debug('PRIV.loadDAform():', '', 64);
        if (!data || !data.onr) {
            JQ('#f_da_onr').val('');
            JQ('#f_da_set').val(0);
            JQ('#f_branch').val('');
            return;
        }
        PRIV.da_onr = data.onr;
        var _unfa = PRIV.branch.slice(0, 4) == 'unfa' ? true : false;
        if (ALL.mobile) {
            JQ('#f_da_onr').val(PRIV.da_onr);
            return;
        }
        JQ.getJSON(JSONURI,
            {
                action: 'postload',
                branch: PRIV.branch,
                direct: PRIV.direct,
                sid: JQ('#f_sid').val(),
                tmpl: _unfa ? 'inpart_da_unfa' : 'inpart_da',
                vps: _unfa ? UNFA.get_vps() : ''
            },
            PRIV.showDAform);
    },

    loadDAs: function () {
        // Lade Liste der Angebote
        BC.debug('PRIV.loadDAs() called!', '', 64);
        JQ.getJSON(JSONURI,
            {
                action: 'list_das',
                sid: JQ('#f_sid').val()
            },
            ALL.showDAs);
    },

    make_gs: function () {
        // Erzeuge GET-String
        BC.debug('PRIV.make_gs():', JQ('#fset_' + PRIV.branch + '_risk :input').serialize(), 64);
        var gs = [];
        if (PRIV.branch.slice(0, 4) == 'unfa') {
            var u = [];
            UNFA.type = PRIV.branch;
            UNFA.add_globals(u);
            BC.debug('PRIV.make_gs(): UNFA.globals =>', u, 64);
            gs.push(JQ.param(u));
            gs.push(JQ.param({vps: UNFA.get_vps()}));
            BC.debug('PRIV.make_gs(): GS so far =>', gs, 64);
        } else {
            if (PRIV.branch === 'fhrd') {
                gs.push(ALL.createQueryStringForMultipleBikes(JQ('#fset_' + PRIV.branch + '_risk :input').serializeArray()));
            } else if (JQ('#fset_' + PRIV.branch + '_risk').length) {
                var serialized = JQ('#fset_' + PRIV.branch + '_risk :input').serialize();

                if ("phvo" === PRIV.branch) {
                    serialized = serialized.replace(/phvo_modprod=&/g, 'phvo_modprod=Bitte ergänzen&')
                    serialized = serialized.replace(/phvo_modtyp=&/g, 'phvo_modtyp=Bitte ergänzen&')
                    serialized = serialized.replace(/phvo_batprod=&/g, 'phvo_batprod=Bitte ergänzen&')
                    serialized = serialized.replace(/phvo_battyp=&/g, 'phvo_battyp=Bitte ergänzen&')
                }

                gs.push(serialized);
            }
        }
        if (PRIV.branch === 'hara' || PRIV.branch === 'hara1' || PRIV.branch === 'hara2') {
            if (JQ('#f_hara2_frd_vs').val() === null) {
                gs.push('&hara2_frd_vs=0')
            }
        }
        gs.push(JQ('#fset_data_vn :input').serialize());
        // Deckungsauftragsangaben wie Vorschäden etc. benötigen wir hier noch nicht!
        JQ('#f_da_set').val(0);
        //gs.push(JQ('#div_add_da input').serialize());
        //gs.push(JQ('#div_add_da textarea').serialize());
        BC.debug('PRIV.make_gs(): GET-String => ', gs, 256);
        console.error(gs);
        return gs;
    },

    make_sa1: function (branch) {
        // Erzeuge serialisierte Arrays für JSON-Call
        if (!JQ('#fset_' + branch + '_risk').length) branch = branch.split('-')[0];
        BC.debug('PRIV.make_sa1(): called for ' + branch, '', 64);
        var r = [].concat(JQ('#fset_' + branch + '_risk :input').serializeArray());
        r = r.concat(JQ('#fset_' + branch + '_risk :checkbox').filter(':checked').serializeArray());
        BC.debug('PRIV.make_sa1(): returns =>', r, 64);
        return r;
    },

    make_sa: function (branch, action) {
        // Erzeuge serialisierte Arrays für JSON-Call
        BC.debug('PRIV.make_sa(): called for ' + branch, '', 64);
        var sa = [];
        if (typeof (action) === 'undefined' || !action) action = 'getpremium';
        if (branch == 'all') {
            JQ.each(PRIV.get_prds(), function (i, v) {
                sa = sa.concat(PRIV.make_sa1(v));
            });
            sa = sa.concat(JQ('#fset_data_vn :input').serializeArray());
        } else if (action == 'getdoc' || action == 'sendda') {
            // Angebot nur für eine Sparte erzeugen
            sa = sa.concat(JQ('#fset_data_vn :input').serializeArray());
            sa = sa.concat(PRIV.make_sa1(branch));
            if (action == 'sendda') {
                sa = sa.concat(JQ('#div_da :input').serializeArray());
                //sa = sa.concat({name: 'da', value: true});
            }
        } else {
            sa = sa.concat(PRIV.make_sa1(branch));
            BC.debug('PRIV.make_sa(' + branch + '):', JQ('#fset_' + branch + '_risk :input').serializeArray(), 256);
        }
        sa = sa.concat({name: 'sid', value: JQ('#f_sid').val()},
            {name: 'action', value: action},
            {name: 'branch', value: branch});

        console.warn(JQ('#f_us_id').prop('disabled'))
        console.warn(JQ('#f_us_id').val())
        if (!JQ('#f_us_id').prop('disabled') && JQ('#f_us_id').val()) {
            sa.concat({name: 'us_id', value: JQ('#f_us_id').val()})
            console.warn('added us_id')
        }

        return sa;
    },

    transformOffer: function (offerData, isFahrrad) {
        var result = []

        var keys = ['fhrd_plz', 'fhrd_vs', 'fhrd_ftype', 'fhrd_mtrl', 'fhrd_kauf', 'fhrd_yprd', 'fhrd_producer', 'fhrd_model', 'fhrd_frame']

        var inputData = offerData.filter(function (inputData) {
            return inputData.name.indexOf('-') !== -1
        });

        result = offerData.filter(function (inputData) {
            return !inputData.name.indexOf('-') !== -1;
        })

        keys.forEach(function (key) {

            var values = [];

            inputData.forEach(function (data) {
                if (data.name.indexOf(key) === 0 && data.value.length !== 0) {
                    values.push(data.value);
                }
                if (data.name.indexOf(key) === 0 && data.value.length === 0) {
                    values.push("");
                }
            })

            result.push({
                name: key,
                value: values.join(','),
            })

        })

        if (FHRD.haveRisk(FHRD.bikes[0]) && FHRD.haveInfo(0)) {
            result.push({
                name: 'fhrd_dv',
                value: '1',
            })
        }

        return result;
    },

    transformMultipleOffersJson: function (offerData) {
        BC.debug("PRIV.transformMultipleOffersJson(): ", offerData, 64)
        ALL.fillFormWithData(offerData);
        var result = [];

        var bikeAmount = 0;

        var keys = ['fhrd_plz', 'fhrd_vs', 'fhrd_ftype', 'fhrd_mtrl', 'fhrd_kauf', 'fhrd_yprd', 'fhrd_producer', 'fhrd_model', 'fhrd_frame'];

        if (offerData['fhrd_vs'].indexOf(',') !== -1) {
            keys.forEach(function (key) {
                Object.keys(offerData).forEach(function (offerKey) {
                    if (offerKey === key) {
                        offerData[key].split(',').forEach(function (value, index) {
                            result.push({
                                name: key + '-' + index,
                                value: value,
                            })
                        })
                    }

                    bikeAmount = offerData[key].split(',').length;
                });
            })
            for (let i = 1; bikeAmount > i; i++) {
                JQ('#add-bike').click();
            }

            result.forEach(function (field) {
                if (JQ('[name="' + field.name + '"]').attr('type') === 'radio') {
                    JQ('[name="' + field.name + '"][value="' + field.value + '"]').click();
                } else {
                    JQ('[name="' + field.name + '"]').val(field.value);
                }
            })

        } else {
            keys.forEach(function (key) {
                if (JQ('[name="' + key + '-0"]').attr('type') === 'radio') {
                    JQ('[name="' + key + '-0"][value="' + offerData[key] + '"]').click();
                } else {
                    JQ('[name="' + key + '-0"]').val(offerData[key]);
                }
            })
        }

        var _plus = offerData.fhrd_plus || "0";
        var _dnls = offerData.fhrd_dnls || "0";
        var _mtrl = offerData.fhrd_mtrl || "1";
        var _marktgarantie = offerData.fhrd_marktgarantie || "0";
        JQ('#f_fhrd_plus_' + _plus).click()
        if (_plus === "1") JQ('#f_fhrd_marktgarantie_' + _marktgarantie).click()
        if (_dnls === "1" && !JQ('#f_fhrd_dnls').is(':checked')) JQ('#f_fhrd_dnls').click();
        if (_dnls === "0" && JQ('#f_fhrd_dnls').is(':checked')) JQ('#f_fhrd_dnls').click();
        JQ('#f_fhrd_mtrl_' + _mtrl).click();

        ALL.data = offerData;
        ALL.fillVN();
        ALL.fillObjAdr();
        FHRD.change();
        JQ('#a_fhrd_show').click();
    },

    recalc: function (e) {
        // Ruft die recalc der jeweiligen Sparte auf!
    },

    requestOffer: function (t) {
        // Fordere Angebot an, das dann vom VN / Vermittler unterschrieben
        // werden kann: https://trac.waldenburger.com/wiki/AngebotsAusgabe
        // requestOffer ist für Schritt 1 aller Vertriebswege
        BC.debug('PRIV.requestOffer():', '', 64);
        var p, q, sa;
        if (!ALL.haveVN()) {
            ALL.showHint('Ohne vollständige Angaben zum VN ist diese Aktion nicht möglich.');
            return;
        }
        if (t == 'DA') {
            sa = PRIV.make_sa(PRIV.branch, 'sendda');
        } else if (PRIV.branch === 'getdocs' || JQ(this).attr('id') == 'btn_getdocs') {
            sa = PRIV.make_sa('all', 'getdoc');
        } else {
            sa = PRIV.make_sa(PRIV.branch, 'getdoc');
        }

        if (ALL.checkIfBikeProdYearIsCurrentYear()) {
            sa.push({
                name: 'fahrradProdYearIsCurrentYear',
                value: '1',
            });
        }

        sa = PRIV.transformOffer(sa, PRIV.branch === 'fhrd');

        p = {
            'vps': UNFA.get_vps(),
            'frm': ALL.deserial(sa),
            'csrf': JQ('body').data('csrf')
        };
        q = JSON.stringify(p);

        JQ.post(JSONURI,
            q,
            ALL.callback);
    },

    reset: function (branch) {
        // Setze alle VS auf 0 und unchecke alle Inputs
        JQ('#div_' + branch + '_risk input').attr('checked', false);
        JQ('#div_' + branch + '_vers input').attr('checked', false);
        switch (branch) {
            case 'hara':
                HARA.reset();
                break;
            case 'phth':
                PHTH.reset();
                break;
            case 'woge':
                WOGE.reset();
                break;
        }
    },

    sendDA: function () {
        // Sende Deckungsauftrag
        BC.debug('PRIV.sendDA()', ' -- Sende Deckungsauftrag --', 64);
        JQ('#btn_da_ok').button('disable');
        PRIV.requestOffer('DA');
    },

    setAdr: function () {
        // Setze alle anderen Anschriftenfelder,
        // unterhalb VN-Reiter nur, wenn noch nicht gefüllt:
        BC.debug('PRIV.setAdr()', PRIV.branch, 64);
        ALL.setAdr(PRIV.branches);
    },

    setDAnr: function (data) {
        BC.debug('PRIV.setDAnr()', data, 64);
        if (!data || !data.onr) {
            JQ('#f_da_onr').val('');
            JQ('#f_da_set').val(0);
            JQ('#f_branch').val('');
            return;
        }
        JQ('#f_da_onr').val(data.onr);
        JQ('#f_branch').val(PRIV.branch);
        PRIV.set_da_vv_yy();
        PRIV.da_link = '/TR/getdoc?' + PRIV.make_gs().join('&');
        PRIV.an_read = false;
        PRIV.wd_read = false;
        JQ('#a_da_offer').off('click');
        JQ('#a_da_wording').off('click');
        JQ('#a_da_offer').click(function (e) {
            e.preventDefault();
            BC.debug('PRIV.setDAnr(): Loading PDF ' + data.onr + ' in new tab:', PRIV.da_link, 64);
            window.open(PRIV.da_link, '_new');
            PRIV.an_read = true;
            JQ('#a_da_offer').css({"color": "#666"});
            PRIV.chkDA();
        });
        JQ('#a_da_wording').click(function (e) {
            e.preventDefault();
            var bparts = PRIV.branch + (PRIV.bparts[PRIV.branch].length ? '-' + PRIV.bparts[PRIV.branch].join('-') : '');
            BC.debug('PRIV.setDAnr(): PRIV.barts, bparts =', [PRIV.bparts[PRIV.branch], bparts], 64);
            window.open('/TR/getzip?zip=B-' + bparts + '.zip', '_new');
            PRIV.wd_read = true;
            JQ('#a_da_wording').css({"color": "#666"});
            PRIV.chkDA();
        });
    },

    set_da_vv_yy: function () {
        // Setze Jahresanzahl, nach denen gefragt wird bei Vorschaden
        // bzw. Vorversicherungsfragen im Deckungsauftragsform
        BC.debug('PRIV.set_da_vv_yy(): Branch is ', PRIV.branch, 64);
        if (PRIV.branch == 'fhrd') {
            PRIV.vv_yy = 3;
            JQ('#div_da_vv6').attr('title', 'Bitte die Anzahl der Schäden innerhalb der letzten 2 Jahre eingeben.');
        } else {
            PRIV.vv_yy = 5;
            JQ('#div_da_vv6').attr('title', 'Bitte die Anzahl der Schäden innerhalb der letzten 5 Jahre eingeben, bei Elementar der letzten 10 Jahre.');
        }
        JQ('#div_da_vv1_1').text('Bestand in den letzten ' + PRIV.vv_yy + ' Jahren für Sie oder ihren Ehe-/Lebenspartner eine Vorversicherung?');
        JQ('#div_da_vv1a').attr('title', 'Bitte erläutern Sie in dem entsprechenden Feld kurz, warum in den letzten ' + PRIV.vv_yy + ' Jahren kein Versicherungsschutz vorhanden war.');
    },

    setDirAnfrage: function (v) {
        BC.debug('PRIV.setDirAnfrage():', v, 64);
    },

    setHNR: function (data) {
        BC.debug('PRIV.setHNR():', data, 64);
        ALL.setHNR(data);
        // Befülle Anschriften-Felder unterhalb "Daten VN", soweit noch nicht bereits gefüllt
        //PRIV.ZUERSset = true;
        PRIV.setAdr();
    },

    setPremium: function (data) {
        // Prüfe auf Mindestprämie und reduziere ggf. ZW-Optionen
        // Setze ggf. Hinweis, dass Mindestprämie gilt
        // Setze Prämienfelder in der Sparte
        BC.debug('PRIV.setPremium():', data, 64);
        var branch = data.branch ? data.branch : PRIV.branch;
        if (branch == 'hara' && data.subbranch == 'sk') branch = 'hara1';
        if (branch === 'hara2') {
            HARA.setPremium(data);
            return;
        }
        ALL.chkError(data);
        if (data.ERROR) {
            return;
        }
        ALL.setZWs(data);
        JQ.each(data, function (key, val) {
            if (JQ('#f_' + branch + '_' + key).length) {
                JQ('#f_' + branch + '_' + key).text(val.str);
            }
            if (key == 'mpr2' && val.val) {
                JQ('#l_' + branch + '_net2').text('Nettoprämie (Mindestprämie!):');
            } else if (key == 'mpr2') {
                JQ('#l_' + branch + '_net2').text('Nettoprämie:');
            }
            if (key == 'brt1' && val.str) {
                ALL.chgProduct(branch, val.str);
            }
        });
    },

    setORT: function (data) {
        BC.debug('PRIV.setORT():', data, 64);
        ALL.setORT(data, PRIV.branches);
    },

    setPLZ: function (data) {
        BC.debug('PRIV.setPLZ():', data, 64);
        ALL.setPLZ(data, PRIV.branches);
    },

    setSTR: function (data) {
        BC.debug('PRIV.setSTR():', data, 128);
        ALL.setSTR(data, PRIV.branches);
    },

    set_vv: function () {
        BC.debug('PRIV.set_vv(): called', '', 64);
        var ibanField = JQ('#f_da_iban');
        ibanField.blur(function () {
            ibanField.val(ibanField.val().toUpperCase());
        });

        if (PRIV.branch === 'fhrd' && ALL.checkIfBikeProdYearIsCurrentYear()) {
            JQ('#fahrrad-vorversicherung-inputs').css('display', 'none')
        }

        if (PRIV.vv.vv3 && PRIV.branch == 'hara2') JQ('#f_da_vv1_1').prop('checked', true);
        if (PRIV.vv.vv3 && PRIV.branch == 'hara2') JQ('#f_da_vv3').val(PRIV.vv.vv3);
        if (PRIV.vv.vv4 && PRIV.branch == 'hara2') JQ('#f_da_vv4').val(PRIV.vv.vv4);
    },

    showAN: function (data) {
        // Zeige Angebots-PDF in neuem Fenster
        BC.debug('PRIV.showAN() called', data, 64);
        if (!data || !data.onr) {
            return;
        }
        var l = ALL.set_an_link(data);
        PRIV.pdfwin.location = l;
    },

    showDA: function (data) {
        BC.debug('PRIV.showDA():', data, 64);
        ALL.showHint(data.text, 0);
    },

    showDAform: function (data) {
        // Fülle #div_da und zeige popup an
        BC.debug('PRIV.showDAform():', '', 64);
        if (data.html == 'ERROR') {
            ALL.showHint('Es ist ein Fehler aufgetreten, die gewünschte Aktion wird abgebrochen.');
            return;
        }
        if (JQ('#div_da').accordion('instance') !== undefined) JQ('#div_da').accordion('destroy');
        JQ('#div_da').html(data.html).dialog('option', 'buttons',
            [{
                click: PRIV.sendDA,
                disabled: true,
                id: 'btn_da_ok',
                text: PRIV.direct ? 'Jetzt kostenpflichtig kaufen' : 'Antrag versenden'
            },
                {
                    click: function () {
                        JQ(this).dialog('close');
                    },
                    text: 'Abbrechen'
                }]);
        JQ('#f_da_onr').val(PRIV.da_onr);
        JQ('#f_branch').val(PRIV.branch);
        PRIV.da_link = '/TR/getdoc?' + PRIV.make_gs().join('&') + '&da_onr=' + PRIV.da_onr;
        PRIV.an_read = false;
        PRIV.wd_read = false;
        PRIV.set_da_vv_yy();
        PRIV.chk4re_ok();

        JQ('#div_da').accordion({
            beforeActivate: function (event, ui) {
                if (ui.newHeader[0]) {
                    // Move to top of new panel by first hiding the previous panel:
                    // https://stackoverflow.com/questions/6677035/jquery-scroll-to-element#6677069
                    ui.oldPanel.hide();
                }
            },
            classes: {'ui-accordion-content': 'high1'},
            collapsible: true,
            heightStyle: "content",
        });

        JQ('#div_da').dialog('open');

        JQ('#a_da_offer').off('click');
        JQ('#a_da_wording').off('click');
        JQ('#a_da_offer').click(function (e) {
            e.preventDefault();
            BC.debug('PRIV.showDAform(): Loading PDF ' + PRIV.da_onr + ' in new tab:', PRIV.da_link, 64);
            window.open(PRIV.da_link, '_new');
            PRIV.an_read = true;
            JQ('#a_da_offer').css({"color": "#666"});
            PRIV.chkDA();
        });
        JQ('#a_da_wording').click(function (e) {
            e.preventDefault();
            var bparts = PRIV.branch + (PRIV.bparts[PRIV.branch].length ? '-' + PRIV.bparts[PRIV.branch].join('-') : '');
            BC.debug('PRIV.showDAform(): PRIV.barts, bparts =', [PRIV.bparts, bparts], 64);
            window.open('/TR/getzip?zip=B-' + bparts + '.zip', '_new');
            PRIV.wd_read = true;
            JQ('#a_da_wording').css({"color": "#666"});
            PRIV.chkDA();
        });
        JQ('#div_da .vp_nonins').click(UNFA.da_no);

        if (JQ('#f_da_za_2').is(':checked')) JQ('#div_da_iban').hide();
        JQ('#a_da_offer').css({"color": ""});
        JQ('#a_da_wording').css({"color": ""});
        JQ('#div_da3 input:checkbox').prop('checked', false);
        JQ('#div_da1 input:checkbox').prop('checked', false);
        JQ('#div_da1 input:radio').prop('checked', false);
        JQ('#div_da1 :text').val('');
        JQ('#f_da_rem').val('');
        JQ('#f_da_vv5').val(in2days);
        JQ('#f_da_vv6').val(0);
        //JQ('#div_da1 textarea').val('');


        console.log(PRIV.vv_yy, '---------------------------------------------------------------------------------------------------------------------')
        PRIV.set_vv();
        BC.appendImageIcons();
        JQ('img.infobtn').click(ALL.showInfo);
        if (PRIV.branch.slice(0, 4) == 'unfa') UNFA.hide_tfbeg();
        ALL.notifyHeight();
    },
}

PRIV.thv = THV;
PRIV.fhrd = FHRD;
PRIV.glas = GLAS;
PRIV.hara = PRIV.hara2 = HARA;
PRIV.phth = PRIV.phth1 = PRIV['phth-ph'] = PHTH;
PRIV.phvo = PHVO;
PRIV.woge = WOGE;
PRIV.unfa = PRIV.unfa1 = PRIV.unfa2 = UNFA;
